import type { SYSTableDef } from "../../../../../../../../_ovlclient/src/library/table/tableapi"

export let tblPackagingSplit: SYSTableDef = {
  id: "PKGPackagingSplit",
  database: {
    dataIdField: "Code",
    dbInsertMode: "Manual",
  },
  server: {
    endpoint: "packaging/split",
  },
  options: {
    initial_paging: { page: 0, pageSize: 200 },
    edit: { editType: "inline" },
    initial_sort: { field: "U_PartId", direction: "asc" },
    filterSortSettings: { enablePersist: false },
  },

  features: {
    filter: true,
    multiSelect: true,
  },

  columns: {
    U_Profile: {
      filter: { columnFilter: { type: "none" } },
      ui: {
        labelTranslationKey: "PKGPackagingPackagingSplitU_Profile",
      },
    },
    U_PartId: {
      ui: {
        labelTranslationKey: "PKGPackagingPackagingSplitU_PartId",
      },
    },
    U_ReqQuantity: {
      ui: {
        labelTranslationKey: "PKGPackagingPackagingSplitU_ReqQuantity",
      },
    },
    QS: {
      ui: {
        labelTranslationKey: "PKGPackagingPackagingSplitQS",
      },
    },
    U_SK: {
      ui: {
        labelTranslationKey: "PKGPackagingPackagingSplitU_SK",
      },
    },
  },
}
